import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';

export default function SectionProjectCarousel(el) {
    const swiperHandle = el.querySelector('.section-project-carousel__cards');
    const swiperPrev = el.querySelector('.section-project-carousel__controls .section-project-carousel__nav-btn--prev');
    const swiperNext = el.querySelector('.section-project-carousel__controls .section-project-carousel__nav-btn--next');
    const swiperScrollbar = el.querySelector('.section-project-carousel__scrollbar');

    const mobilePrev = el.querySelector('.section-project-carousel__headline-wrapper .section-project-carousel__nav-btn--prev');
    const mobileNext = el.querySelector('.section-project-carousel__headline-wrapper .section-project-carousel__nav-btn--next');

    // setTimeout is to resolve a tiny 1px gap that sometimes appears at the end of the slider
    setTimeout(() => {
        new Swiper(swiperHandle, { // eslint-disable-line no-new
            modules: [
                Navigation,
                Scrollbar,
            ],
            slidesPerView: 'auto',
            spaceBetween: 5,
            navigation: {
                prevEl: mobilePrev,
                nextEl: mobileNext,
            },
            scrollbar: {
                el: swiperScrollbar,
                draggable: true,
                hide: false,
            },
            breakpoints: {
                992: {
                    spaceBetween: 10,
                    navigation: {
                        prevEl: swiperPrev,
                        nextEl: swiperNext,
                    },
                },
            },
        });
    }, 500);
}
